module.exports = __webpack_public_path__ + "img/4.027d309c.jpg";